import { Navbar } from "@ui-components/sections/Navbar";
import { Hero } from "@ui-components/sections/Hero";
import { Customers } from "@ui-components/sections/S1_Customers";
import { Services } from "@ui-components/sections/S2_Services";
import { About } from "@ui-components/sections/S3_About";
import { Contact } from "@ui-components/sections/S4_Contact";
import { Footer } from "@ui-components/sections/Footer";

export const MainLayout = () => {
    return (
        <div>
            <Navbar />
            <Hero />
            <Customers />
            <Services />
            <About />
            <Contact />
            <Footer />
        </div>
    );
};